<template>
  <div>
    <common-table
        :table-columns="tableColumns"
        :url="url"
        :operate="operate"
        :form-fields="formFields"
        :permission="permission"
        :buttons="buttons"
        :searchs="searchs"
        @returnId="returnId"
        ref="table"
    ></common-table>

    <el-dialog
        title="重置店铺"
        :visible.sync="resetDialogVisible"
        @open="handleDialogOpen"
    @close="resetForm('resetNameForm')"
    >
    <el-form
        label-position="right"
        label-width="120px"
        :model="resetNameForm"
        ref="resetForm">
    <el-form-item
        label="重置店铺:"
        prop="name"
        :rules="[{ required: true, message: '请输入店铺名称', trigger: 'blur'}]"
    >
      <el-input
          v-model="resetNameForm.name"
          placeholder="请输入店铺名称"
      ></el-input>
    </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="resetDialogVisible = false">取消</el-button>
      <el-button type="primary" @click="submitResetForm('resetForm')">确定</el-button>  <!-- 修正ref名称 -->
    </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import request from "@/utils/axios";
import message from "@/utils/message";

export default {
  name: 'ProductAuthorization',
  components: {CommonTable},
  data() {
    return {
      batchForm: {
        ids: '',
      },
      resetDialogVisible: false, // 控制对话框显示的正确变量
      resetNameForm: { name: '' }, // 正确的表单数据对象
      userIds: [],
      selectIds: [],
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'phone',
        placeholder: '手机号',
        type: 'input'
      }, {
        name: 'name',
        placeholder: '授权账号',
        type: 'input'
      }, {
        name: 'shopName',
        placeholder: '店铺名称',
        type: 'input'
      }, {
        name: 'authorizationStatus',
        placeholder: '平台类型',
        type: 'select',
        selectValue: [{
          key: 0,
          value: '未授权',
        }, {
          key: 1,
          value: '申请授权',
        }, {
          key: 2,
          value: '店铺错误',
        }]
      },],
      permission: {
        add: 'productAuthorization:add',
        update: 'productAuthorization:update',
        delete: 'productAuthorization:delete',
        deleteBatch: 'productAuthorization:deleteBatch'
      },
      url: {
        get: '/productAuthorization/listByCondition',
        add: '/productAuthorization/add',
        update: '/productAuthorization/update',
        delete: '/productAuthorization/delete',
        delete_batch: '/productAuthorization/deleteBatch',
        status: '/productAuthorization/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }, {
        field: 'phone',
        label: '用户',
        sort: false,
        show: true,
      }, {
        field: 'name',
        label: '抖音昵称',
        sort: false,
        show: true,
      }, {
        field: 'shopName',
        label: '店铺名称',
        sort: false,
        show: true,
      }, {
        field: 'authorizationStatus',
        label: '授权状态',
        sort: false,
        show: {
          type: 'tag',
          tags: [{
            key: 0,
            value: '未授权',
            type: 'info'
          }, {
            key: 1,
            value: '已授权',
            type: 'success'
          }, {
            key: 2,
            value: '店铺异常',
            type: 'info'
          }]
        },
      },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',
            label: 'ID',
            type: 'input',
            add: false,
            update: true
          },
          {
            field: 'name',
            label: 'name',
            type: 'input',
            placeholder: '请输入name',
            rules: [
              {required: true, message: 'name不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'shopName',
            label: 'shopName',
            type: 'input',
            placeholder: '请输入shopName',
            rules: [
              {required: true, message: 'shopName不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'authorizationStatus',
            label: 'authorizationStatus',
            type: 'input',
            placeholder: '请输入authorizationStatus',
            rules: [
              {required: true, message: 'authorizationStatus不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: [],
      buttons: [
        {
          icon: 'el-icon-circle-check',
          type: 'success',
          text: '批量修改店铺状态',
          permission: 'productAuthorization:update',
          click: () => {
            console.log(this.selectIds)
            if (this.selectIds.length <= 0) {
              this.$message.warning('请先选择需要修改的记录')
              return
            }
            this.batchForm.ids = this.selectIds.join(",")
            request.post({
              url: '/productAuthorization/bathShopStatus',
              data: this.batchForm,
              success: (res) => {
                if (res.code === 0) {
                  message.success("批量修改抖音号成功");
                  this.$refs.table.getData()
                } else {
                  message.error(res.msg);
                }
              }
            });
          }
        },
        {
          icon: 'el-icon-video-camera',
          type: 'text',
          text: '重置状态',
          permission: 'productAuthorization:update',
          // 方案1：使用箭头函数并保存this
          click: (row) => {
            console.log('点击重置状态按钮，row数据:', row);
            this.submitReset(row);
          }
          /* 方案2：使用bind显式绑定this
          click: function(row) {
            console.log('点击重置状态按钮，row数据:', row);
            this.submitReset(row);
          }.bind(this)
          */
        },
      ]
    }
  },
  methods: {
    submitReset(row) {
      // 确保row存在且有name属性
      const shopName = row && row.name ? row.name : '';
      this.resetNameForm = { name: shopName };
      this.resetDialogVisible = true;
      console.log('对话框已触发显示，resetDialogVisible:', this.resetDialogVisible);
    },
    returnId(data) {
      this.selectIds = data;
      console.log('选中ID集合:', this.selectIds);
    },
    resetForm(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
    },
    submitResetForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          request.post({
            url: '/productAuthorization/resetShopStatus',
            data: this.resetNameForm,
            success: (data) => {
              if (data.code === 0) {
                message.success("重置店铺状态成功");
                this.resetDialogVisible = false;
                this.$refs.table.getData();
              } else {
                message.error(data.msg);
              }
            }
          });
        }
      })
    },
  }
}
</script>

<style scoped>
/* 可根据需要添加样式 */
</style>